import PropTypes from 'prop-types';
import React from 'react';
import { Flex } from 'roo-ui/components';

const ContentWrapper = ({ children, ...rest }) => (
  <Flex {...rest} flexDirection="column" data-print-style="content-wrapper" data-testid="content-wrapper">
    {children}
  </Flex>
);

ContentWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
};

ContentWrapper.displayName = 'ContentWrapper';

export default ContentWrapper;
